export const TRACKING_MODES = ['off', 'onDuty', 'always'] as const;
export type TrackingMode = (typeof TRACKING_MODES)[number];

export const TRACKING_PRECISIONS = ['coarse', 'precise'] as const;
export type TrackingPrecision = (typeof TRACKING_PRECISIONS)[number];

export interface StoredTracking {
  trackingMode?: string | null;
  trackingPrecision?: string | null;
  isTracked?: boolean | null;
}

export interface TrackingFormValue {
  trackingMode: TrackingMode;
  trackingPrecision: TrackingPrecision;
  isTracked: boolean;
}

const isMode = (value: unknown): value is TrackingMode =>
  TRACKING_MODES.includes(value as TrackingMode);

const isPrecision = (value: unknown): value is TrackingPrecision =>
  TRACKING_PRECISIONS.includes(value as TrackingPrecision);

/** Reads the form value, including users that only have legacy isTracked. */
export const trackingFormValueFromUser = (source?: StoredTracking | null): TrackingFormValue => {
  if (isMode(source?.trackingMode)) {
    return {
      trackingMode: source.trackingMode,
      trackingPrecision: isPrecision(source.trackingPrecision) ? source.trackingPrecision : 'coarse',
      isTracked: source.trackingMode !== 'off',
    };
  }
  if (source?.isTracked) {
    return { trackingMode: 'onDuty', trackingPrecision: 'precise', isTracked: true };
  }
  return { trackingMode: 'off', trackingPrecision: 'coarse', isTracked: false };
};

export const trackingWritePayload = (
  trackingMode: TrackingMode,
  trackingPrecision: TrackingPrecision,
): TrackingFormValue => ({
  trackingMode,
  trackingPrecision: trackingMode === 'off' ? 'coarse' : trackingPrecision,
  isTracked: trackingMode !== 'off',
});
